'use client';

import type { StaticImageData } from 'next/image';
import Image from 'next/image';

import type { ModalProps } from '../components';
import { CircleCloseButton, ModalBase } from '../components';
import styles from './image-modal.component.module.scss';

// memo: VisualModal で吸収する可能性有

type Props = Omit<ModalProps, 'children' | 'isOpen'> & {
  /**
   * 画像の alt 属性を指定します
   */
  alt: string;
  /**
   * 画像の src を指定します
   */
  src: string | StaticImageData;
  /**
   * aria-labelを指定します。
   */
  title: string;
  /**
   * モーダルの閉じるボタンを自動フォーカスするかどうかを指定します
   */
  autoFocusCloseButton?: boolean;
  isOpen?: boolean;
};

const imageModalStyle = {
  content: {
    top: '50%',
    left: '50%',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    padding: '0', // デフォルトの打ち消し
    border: 'none', // デフォルトの打ち消し
  },
  overlay: {
    backgroundColor: 'var(--fds-color-background-overlay, rgba(0, 0, 0, 0.8))',
    zIndex: 1031, // Header の zIndex が 1030 なのでそれより上にする
  },
};

export const ImageModal = ({
  alt,
  src,
  title,
  className,
  autoFocusCloseButton = true,
  isOpen = true,
  ...rest
}: Props) => {
  return (
    <ModalBase
      className={[className, styles.imageModal].filter(Boolean).join(' ')}
      contentLabel={title}
      isOpen={isOpen}
      {...rest}
      shouldCloseOnOverlayClick={true}
      style={imageModalStyle}
    >
      <CircleCloseButton
        aria-label="閉じる"
        autoFocus={autoFocusCloseButton}
        type="button"
        onClick={rest.onRequestClose}
      />
      <Image
        alt={alt}
        className={styles.imageElement}
        height={400}
        src={src}
        width={720}
      />
    </ModalBase>
  );
};
